import { render, staticRenderFns } from "./videoUploader.vue?vue&type=template&id=ccf748e6&scoped=true"
import script from "./videoUploader.vue?vue&type=script&lang=js"
export * from "./videoUploader.vue?vue&type=script&lang=js"
import style0 from "./videoUploader.vue?vue&type=style&index=0&id=ccf748e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf748e6",
  null
  
)

export default component.exports